import { applyPolyfills, defineCustomElements, } from '@juntossomosmais/atomium/loader';
function toKebabCase(str) {
    return str.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
}
export const ComponentLibrary = {
    async install() {
        applyPolyfills().then(() => {
            defineCustomElements(window, {
                ce: (eventName, opts) => new CustomEvent(eventName.startsWith('atom') ? toKebabCase(eventName) : eventName, opts),
            });
        });
    },
};
//# sourceMappingURL=plugin.js.map